import { ImageFragment, isImageFragment } from './ImageFragment'

import userImageFragmentRawString from '../UserImageFragment.graphql'

export const userImageFragmentString = userImageFragmentRawString

export type UserImageFragment = ImageFragment & {
  __typename: 'Image'
  createdAt: string
}

export const isUserImageFragment = (
  fragment: any,
): fragment is UserImageFragment =>
  (isImageFragment(fragment) as boolean) &&
  fragment.__typename === 'Image' &&
  typeof fragment.createdAt === 'string'
